// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Column, VSpacer } from './Layout';
import Overlay from './Overlay';
import { CloseIcon } from './Icons';

const OverlayBackground = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BlueBox = styled.div`
  background-color: ${(props) => props.theme.technicalErrorColor};
  color: white;
  width: 100%;
`;

type Props = {
  id: string,
  siblingId?: string,
  onClose?: (event: any) => void,
};

export default class TechnicalError extends Component<Props> {
  handlekeydown = (e: any) => {
    if (e.which === 27) {
      this.props.onClose();
    } else {
      e.preventDefault();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handlekeydown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handlekeydown, false);
  }

  render() {
    return (
      <Overlay id={this.props.id} siblingId={this.props.siblingId}>
        <OverlayBackground>
          <Row style={{ width: '100%' }}>
            <Column offsetLarge={3} small={12} large={6}>
              <BlueBox>
                <VSpacer small={3} />
                <Row
                  style={{
                    margin: '0 0.75rem',
                    justifyContent: 'space-between',
                  }}
                >
                  <Column small={10}>{this.props.children}</Column>
                  <Column
                    small={1}
                    style={{
                      alignItems: 'flex-end',
                      justifyContent: 'center',
                    }}
                  >
                    <div
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={this.props.onClose}
                    >
                      <CloseIcon />
                    </div>
                  </Column>
                </Row>
                <VSpacer small={3} />
              </BlueBox>
            </Column>
          </Row>
        </OverlayBackground>
      </Overlay>
    );
  }
}
